import {
  isCatalogRecommendationTraitConfig,
  type TraitConfig,
} from "@hightouch/lib/query/visual/types/trait-definitions";

import { PropertyComparisonType, TraitType } from "src/types/visual";

import { CatalogRecommendationRankFilter } from "./catalog-recommendation-rank-filter";
import { CepModelPropertyFilter } from "./cep-model-property-filter";
import { JourneyEventPropertyOperatorValueFilter } from "./event-property-operator-value-filter";
import { PredictivePropertyOperatorValueFilter } from "./predictive-property-operator-value-filter";
import { PropertyOperatorValueFilter } from "./property-operator-value-filter";

type FilterTrait =
  | { type?: string | null; config?: unknown }
  | null
  | undefined;

export const isCatalogRecommendationTrait = (trait: FilterTrait): boolean =>
  Boolean(
    trait?.type &&
      trait.config &&
      isCatalogRecommendationTraitConfig(
        trait.type as TraitType,
        trait.config as TraitConfig,
      ),
  );

export const getPropertyValueFilter = ({
  isControlPlaneProperty,
  trait,
  propertyComparisonType,
}: {
  isControlPlaneProperty: boolean;
  trait: FilterTrait;
  propertyComparisonType: PropertyComparisonType;
}) => {
  if (isControlPlaneProperty) return CepModelPropertyFilter;
  if (isCatalogRecommendationTrait(trait))
    return CatalogRecommendationRankFilter;
  if (trait?.type === TraitType.Predictive)
    return PredictivePropertyOperatorValueFilter;
  if (propertyComparisonType === PropertyComparisonType.JourneyEntryEvent)
    return JourneyEventPropertyOperatorValueFilter;
  return PropertyOperatorValueFilter;
};
